import React, { useEffect, useRef, useState } from "react";
import viewBg from "assets/images/common/others/viewBg.png";
import { ReactComponent as DeleteIconSvg } from "assets/images/common/svgs/delete.svg";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import { ReactComponent as ArrowDownIcon } from "assets/images/common/svgs/ArrowDownIcon.svg";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";

import ProfileUSer from "assets/images/common/others/profile-user-img.png";
import { useNavigate } from "react-router-dom";
import PersonalInformation from "./component/PersonalInformation";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import RsvpEvents from "./component/RsvpEvents";
import useUsers from "containers/user-management/useHooks";
import useUtils from "hooks/useUtils";
import { useSelector } from "react-redux";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

interface Tab {
  name: string;
  Component: JSX.Element;
}

const ViewRSVP = () => {
  const [user, setUser] = useState<any>({});
  const tabs: Tab[] = [
    {
      name: "Personal Information",
      Component: <PersonalInformation user={user} />,
    },
    { name: "Events", Component: <RsvpEvents rsvpId={user?.user?.id} /> },

  ];
  const { getUserById, getEventsById } = useUsers();
  const { getQueryParams } = useUtils();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const params = getQueryParams();
  console.log(params?.id);
  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);
  const navigate = useNavigate();

  useEffect(() => {
    getUserById(params?.id, setUser);
  }, []);

  const goToBack = () => {
    navigate(-1);
  };
  return (
    <div className="pb-5">
      <div className="flex justify-between items-center gap-4 mb-6">
        <h1 className="text-base text-primaryText font-bold flex items-center gap-3">
          <span
            onClick={goToBack}
            className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
          >
            <ArrowBackIcon />
          </span>
          {`${user?.user?.firstName || "-"} ${user?.user?.lastName || "-"} `}’s
          Profile
        </h1>
        {/* <div className="flex items-center gap-6">
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-primaryText">Block User</p>
            <label className="switch-field-small">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </span>
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-redtext">Delete User</p>
            <DeleteIconSvg />
          </span>
        </div> */}
      </div>

      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-6 w-full">
        <div className="flex  items-center gap-2 pb-4">
          <span>
            <img
              className="w-[82px] h-[82px] rounded-full"
              src={
                user?.user?.profilePicUrl
                  ? concatPathWithBackendUrl(
                    user?.user?.profilePicUrl?.fileDownloadUri
                  )
                  : editProfilePicUser
              }
            />
          </span>
          <span>
            <h2 className="text-base whitespace-nowrap font-bold text-primaryText">
              {`${user?.user?.firstName} ${user?.user?.lastName}`}’s Profile
            </h2>
            <p className="text-xs font-medium text-primaryText">
              {user?.user?.email}
            </p>
          </span>
        </div>
        <div className=" flex gap-4">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`rounded-md px-3 py-2 font-medium text-xs transition-colors duration-300 ${activeTab.name === tab.name
                ? "bg-vibrantBlueBg text-white "
                : "bg-warmOffWhiteBg text-mediumGrayText"
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.name}
            </button>
          ))}
        </div>
        <div className="mt-4">
          <div className="mt-4">
            {activeTab.name === "Personal Information" ? (
              <PersonalInformation user={user} />
            ) : activeTab.name === "Events" ? (
              <RsvpEvents rsvpId={user?.user?.id} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewRSVP;
